/* eslint-disable react/jsx-props-no-spreading */
import { useForm } from '@folklore/forms';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { useApi } from '../../contexts/ApiContext';
import { useUrlGenerator } from '../../contexts/RoutesContext';
import SubmitButton from '../buttons/Submit';
import FormGroup from '../fields/FormGroup';
import TextField from '../fields/Text';
import ArrowIcon from '../icons/Arrow';
// import SocialIcon from '../icons/Social';
// import IconLink from '../partials/IconLink';
import Link from '../partials/Link';

import styles from '../../../styles/forms/login.module.scss';

const propTypes = {
    onComplete: PropTypes.func,
};

const defaultProps = {
    onComplete: null,
};

const LoginForm = ({ onComplete }) => {
    const route = useUrlGenerator();
    const intl = useIntl();
    const api = useApi();
    const login = useCallback(
        (action, { email, password }) => api.auth.login(email, password),
        [api],
    );
    const { fields, onSubmit, loading } = useForm({
        postForm: login,
        fields: ['email', 'password'],
        onComplete,
    });

    return (
        <form action={route('login')} onSubmit={onSubmit}>
            {/* <div className={styles.otherOptions}>
                <IconLink
                    className={styles.signOnBtn}
                    icon={<SocialIcon type="facebook" />}
                    href={route('login.provider', {
                        social_provider: 'facebook',
                    })}
                    external
                    target="_self"
                >
                    <FormattedMessage
                        defaultMessage="Login with Facebook"
                        description="Button label"
                    />
                </IconLink>
            </div> */}
            <FormGroup
                {...fields.email}
                label={<FormattedMessage defaultMessage="Email" description="Field label" />}
            >
                <TextField
                    {...fields.email}
                    type="text"
                    placeholder={intl.formatMessage({
                        defaultMessage: 'email@email.ca',
                        description: 'Field placeholder',
                    })}
                    required
                />
            </FormGroup>
            <FormGroup
                {...fields.password}
                label={<FormattedMessage defaultMessage="Password" description="Field label" />}
            >
                <TextField
                    {...fields.password}
                    type="password"
                    placeholder={intl.formatMessage({
                        defaultMessage: 'password',
                        description: 'Field placeholder',
                    })}
                    required
                />
            </FormGroup>
            <div className={styles.formActions}>
                <SubmitButton
                    className={styles.formSubmitBtn}
                    icon={<ArrowIcon />}
                    iconPosition="right"
                    loading={loading}
                    disabled={loading}
                >
                    <FormattedMessage defaultMessage="Log in" description="Button label" />
                </SubmitButton>
                <Link className={styles.helpLink} href={route('password.request')}>
                    <FormattedMessage
                        defaultMessage="Forgot your password?"
                        description="Button label"
                    />
                </Link>
            </div>
            <p className={styles.notice}>
                *
                <FormattedMessage
                    defaultMessage="If you previously connected with Facebook you can create a password by clicking"
                    description="Button label"
                />
                &nbsp;
                <Link className={styles.helpLink} href={route('password.request')}>
                    <FormattedMessage defaultMessage="forgot password" description="Button label" />
                </Link>
                &nbsp;
                <FormattedMessage
                    defaultMessage="and setting a new password with the email you connect with on Facebook."
                    description="Button label"
                />
            </p>
        </form>
    );
};
LoginForm.propTypes = propTypes;
LoginForm.defaultProps = defaultProps;

export default LoginForm;
